import { render, staticRenderFns } from "./TuitionBillChart.vue?vue&type=template&id=7d527e7c&scoped=true"
import script from "./TuitionBillChart.vue?vue&type=script&lang=js"
export * from "./TuitionBillChart.vue?vue&type=script&lang=js"
import style0 from "./TuitionBillChart.vue?vue&type=style&index=0&id=7d527e7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d527e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d527e7c')) {
      api.createRecord('7d527e7c', component.options)
    } else {
      api.reload('7d527e7c', component.options)
    }
    module.hot.accept("./TuitionBillChart.vue?vue&type=template&id=7d527e7c&scoped=true", function () {
      api.rerender('7d527e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/TuitionBillChart.vue"
export default component.exports